import { render, staticRenderFns } from "./batch-detail.vue?vue&type=template&id=1ef5339b&scoped=true&"
import script from "./batch-detail.vue?vue&type=script&lang=js&"
export * from "./batch-detail.vue?vue&type=script&lang=js&"
import style0 from "./batch-detail.vue?vue&type=style&index=0&id=1ef5339b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef5339b",
  null
  
)

/* custom blocks */
import block0 from "./locales.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Fgitlab-runner%2Fbuilds%2F7624f89f%2F0%2Ftokyo-auction%2Ftokyo-auction-frontend%2Fsrc%2Fviews%2Forders%2Fbatch-detail.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports